module.exports = __webpack_public_path__ + "dashboard/img/hamburger.14220c6ff8d1f901997398970b93c29a.svg";